import React, { useEffect, useRef, useState } from "react";
import SalesGraph from "./SalesGraph";
import SalesGraph2 from "./SalesGraph2";
import LatestMembers from "./LatestMembers";
import DirectChat from "./DirectChat";
import ToDoList from "./ToDoList";
import LatestOrders from "./LatestOrders";

function DashboardCharts() {
  return (
    <section className="content" style={{ marginTop: 20 }}>
      <div className="container-fluid">
        <div
          className="setOne"
          style={{ display: "flex", flexDirection: "row", gap: 10 }}
        >
          <SalesGraph />
          <SalesGraph2 />
        </div>

        <div
          className="setTwo"
          style={{ display: "flex", flexDirection: "row", gap: 10 }}
        >
          <ToDoList />
          <DirectChat />
        </div>

        <div
          className="setTwo"
          style={{ display: "flex", flexDirection: "row", gap: 10 }}
        >
          <LatestOrders />
          <LatestMembers />
        </div>
      </div>
    </section>
  );
}

export default DashboardCharts;
